var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 2.66659C4.45623 2.66659 2.66536 4.45745 2.66536 6.66659C2.66536 8.87572 4.45623 10.6666 6.66536 10.6666C8.8745 10.6666 10.6654 8.87572 10.6654 6.66659C10.6654 4.45745 8.8745 2.66659 6.66536 2.66659ZM1.33203 6.66659C1.33203 3.72107 3.71985 1.33325 6.66536 1.33325C9.61088 1.33325 11.9987 3.72107 11.9987 6.66659C11.9987 7.89906 11.5806 9.03389 10.8786 9.93701L14.4701 13.5285C14.7305 13.7889 14.7305 14.211 14.4701 14.4713C14.2098 14.7317 13.7876 14.7317 13.5273 14.4713L9.93579 10.8798C9.03267 11.5819 7.89784 11.9999 6.66536 11.9999C3.71985 11.9999 1.33203 9.6121 1.33203 6.66659Z",
    fill: "#85929A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0a5e07df0561587834521ae8515c2c26.svg";
export { ForwardRef as ReactComponent };